import {  useEffect,useState} from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios"; 
import "../../styles/owner/HomeOwner.css"; // Import the CSS file for styling
import BASE_URL from "../../BaseUrl";

export default function CourseSection({message, setMessage, showMessage, setShowMessage , adminId}) {
    const [editCourse, setEditCourse] = useState(false);
    // State to hold the list of courses
    const [courses, setCourses] = useState([]);
    // State to hold the course name input
    const [course, setCourse] = useState({
        name: "",
        courseId: ""
    });
    const [courseIdTodelete, setCourseIdToDelete] = useState('');
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
    const [isReloading, setIsReloading] = useState(false);
    const navigate = useNavigate();


    

    useEffect(() => {
        axios.get(`${BASE_URL}/owner/admin-courses?adminId=${adminId}`,{withCredentials: true})
        .then((response)=>{
            setCourses(response.data);
        }).catch((error)=>{
            navigate("/");
        })

    }, [isReloading,navigate,adminId]);

    const deleteCourse = (courseId) => {
        axios.delete(`${BASE_URL}/owner/delete-course?courseId=${courseId}`, { withCredentials: true })
        .then((response) => {
            setIsReloading(!isReloading); // toggle isReloading to refresh the courses list
        }).catch((error) => {
            setMessage(error.response.data || "An error occurred while deleting the course.");
            setShowMessage(true);
        })
    }

    const updateCourse = () =>{
        axios.put(`${BASE_URL}/owner/update-course`, course, { withCredentials: true })
        .then((response) => {
            setMessage(response.data);
            setShowMessage(true);
            setEditCourse(false);
            setIsReloading(!isReloading); // toggle isReloading to refresh the courses list
        }).catch((error) => {
            setMessage(error.response.data || "An error occurred while updating the course.");
            setShowMessage(true);
            setEditCourse(false);
        })
    }
    return(
        <div className="courses-section-container">
            <h2>الكورسات</h2>
            <table className="courses-table">
                <thead>
                    <tr>
                        <th>اسم المادة</th>
                        <th>الكود التعريفي</th>
                        <th>تعديل</th>
                        <th>حذف</th>
                    </tr>
                </thead>
                <tbody>
                    {courses.map((course)=>{
                        return (
                            <tr key={course.courseId}>
                                <td>{course.name}</td>
                                <td>{course.courseId}</td>
                                <td><button onClick={()=>{setCourse(course);setEditCourse(true)}}>تعديل</button></td>
                                <td><button onClick={()=>{
                                    setCourseIdToDelete(course.courseId);
                                    setShowDeleteConfirmation(true);
                                }}>حذف</button></td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>


            {editCourse && (
                <div className="overlay">
                <div className="add-course-form">
                    <h3>تعديل المادة</h3>
                    <label > اسم المادة</label>
                    <input type="text" value={course.name} onChange={(e) => setCourse({...course, name:e.target.value})} />
                    <div className="edit-admin-buttons">
                        <button onClick={updateCourse}>تعديل</button>
                        <button onClick={() => setEditCourse(false)}>الغاء</button> 
                    </div>
                </div>
                </div>
            )}
            {showDeleteConfirmation && (
                <div className="overlay">
                    <div className="add-course-form">
                        <p>هل أنت متأكد أنك تريد حذف هذه المادة؟</p>
                        <div className="edit-admin-buttons">
                            <button style={{ backgroundColor: "green", color: "white" }} onClick={() => setShowDeleteConfirmation(false)}>لا</button>
                            <button style={{ backgroundColor: "red", color: "white" }} onClick={() => {deleteCourse(courseIdTodelete); setShowDeleteConfirmation(false);}}>نعم</button>
                        </div>
                    </div>
                </div>
            )}
        </div>

    )
}
